<div *ngFor="let field of systemFields" fxLayoutGap="20px">
  <div fxLayout="column" class="form-item">
    <b class="item-title" [innerHTML]="field.key | safeHtml"></b>
    <span
      class="value"
      [ngClass]="{
        'attribute-value-no-value': !field.value
      }"
      [innerHTML]="(field.value?.length > 0 ? field.value : noValueText) | safeHtml"
    ></span>
    <mat-divider class="divider"></mat-divider>
  </div>
</div>

<div *ngFor="let attribute of flatAttributes" fxLayoutGap="20px">
  <div fxLayout="column" class="form-item">
    <b
      class="item-title"
      [innerHTML]="
        (useDescription ? (attribute.description?.length ? attribute.description : attribute.name) : attribute.name)
          | safeHtml
      "
    ></b>
    <ng-container *ngIf="attribute?.type === 'Skill'" class="value">
      <div class="value">
        <skill [selectedSkillLevel]="attribute.attributes[0].attributeDefinitionValueListItem"></skill>
      </div>
    </ng-container>
    <ng-container *ngIf="attribute?.type === 'StarRating'">
      <div class="value">
        <app-star-rating-attribute
          [selectedStarRating]="attribute.attributes[0].attributeDefinitionValueListItem"
        ></app-star-rating-attribute>
      </div>
    </ng-container>
    <ng-container *ngIf="attribute?.type === 'Complex'">
      <div *ngFor="let complexAttributeValue of attribute?.complexAttributeValues" class="value">
        <app-complex-field-viewer [complexAttributeValue]="complexAttributeValue"></app-complex-field-viewer>
      </div>
    </ng-container>
    <ng-container
      *ngIf="
        attribute?.type !== 'EncryptedField' &&
        attribute?.type !== 'Complex' &&
        attribute?.type !== 'Skill' &&
        attribute?.type !== 'StarRating'
      "
    >
      <span
        class="value"
        [ngClass]="{
          'attribute-value-no-value': !attrValue.hasValue()
        }"
        *ngFor="let attrValue of attribute.attributes"
        [innerHTML]="(attrValue.hasValue() ? attrValue.value : noValueText) | safeHtml"
      ></span>
    </ng-container>

    <ng-container *ngIf="attribute?.type == 'EncryptedField'">
      <span
        class="value"
        [ngClass]="{
          'attribute-value-no-value': !attrValue.hasValue()
        }"
        *ngFor="let attrValue of attribute.attributes"
        [innerHTML]="(attrValue.hasValue() ? '***' : noValueText) | safeHtml"
      ></span>
    </ng-container>

    <mat-divider class="divider"></mat-divider>
  </div>
</div>
